import { render, staticRenderFns } from "./Addr.vue?vue&type=template&id=547a77d6&scoped=true&"
import script from "./Addr.vue?vue&type=script&lang=js&"
export * from "./Addr.vue?vue&type=script&lang=js&"
import style0 from "./Addr.vue?vue&type=style&index=0&id=547a77d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547a77d6",
  null
  
)

export default component.exports